import { useCallback, useEffect, useState } from 'react';

export const THEME_KEY = 'wp.theme'; // 'dark' | 'light'; absent = follow the system. The editor and landing page use the same key.

export const readSiteTheme = () => {
  try { const v = localStorage.getItem(THEME_KEY); if (v === 'dark' || v === 'light') return v; } catch { /* private mode */ }
  return window.matchMedia?.('(prefers-color-scheme: dark)')?.matches ? 'dark' : 'light';
};

/** Light / dark for pages outside the editor (subscribe, success): the visitor's choice wins, else the system's. */
export const useSiteTheme = () => {
  const [theme, setTheme] = useState(readSiteTheme);
  useEffect(() => { document.documentElement.classList.toggle('dark', theme === 'dark'); }, [theme]);
  useEffect(() => {
    const mq = window.matchMedia?.('(prefers-color-scheme: dark)');
    const onChange = () => { try { if (localStorage.getItem(THEME_KEY)) return; } catch { /* ignore */ } setTheme(mq.matches ? 'dark' : 'light'); };
    mq?.addEventListener?.('change', onChange);
    return () => mq?.removeEventListener?.('change', onChange);
  }, []);
  const toggle = useCallback(() => {
    setTheme((t) => {
      const next = t === 'dark' ? 'light' : 'dark';
      try { localStorage.setItem(THEME_KEY, next); } catch { /* private mode */ }
      return next;
    });
  }, []);
  return [theme, toggle];
};
